/**
 * 法语（fr）
 */

export default {
  // 刊登编辑页面 edit
  publishEdit: {
    listings: 'Liste',
    Platform: 'Plate - forme',
    Store: 'Magasins',
    ProductTitle: 'Nom du produit',
    Tags: 'Étiquettes',
    Custom: 'Les habitudes',
    Collections: 'Collection',
    Description: 'Description',
    Variants: 'Variante',
    Images: 'Photos',
    listNow: 'Liste maintenant',
    CancelEditing: "Annuler l'édition",
    tips1: 'Pas plus de 40 000 caractères',
    tips2: 'Seules les images JPG, JPEG et PNG sont prises en charge.',
    ShippingMethod: 'Mode de transport',
    Product: 'Produits',
    SKU: 'SKU',
    size: 'Taille',
    color: 'Couleur',
    ProductCost: 'Coût du produit',
    ShippingCost: 'Frais de transport',
    CompareAtPrice: 'Comparaison des prix',
    SuggestedPrice: 'Prix suggéré',
    Profi: 'Bénéfices',
    Quantity: 'Nombre',
    tips3: 'Y compris les compagnies maritimes',
    tips4: "Prend en charge jusqu'à 250 images",
    tips5: "Prend en charge jusqu'à 40 images",
    SuggestedPriceTips1: "Prix de vente = prix d'origine * (1 + supplément) + Fret",
    CompareAtPriceTips1: 'Comparaison par prix = coût du produit * (1 + marge bénéficiaire) + coût du transport',
    SuggestedPriceTips2: '(si vous avez sélectionné inclure le fret)',
    SuggestedPriceTips3: 'Tous les prix peuvent être modifiés en un seul clic',
    NewPrice: 'Nouveaux prix',
    cancel: 'Annulation',
    confirm: 'Confirmation',
    Percentage: 'Pourcentage',
    OneClickModification: 'Modifier en un clic',
    ProductionEditor: 'Éditeur de produits',
    SyncCollection: 'Ensemble de correspondance',
    selectContent: 'Sélectionner le contenu',
    ShippingFrom: 'Point de départ',
    ShippingTo: 'Point final',
    EstimatedDeliveryTime: 'Délai de livraison prévu',
    NoPictures: 'Pas de photos',
    loadingText: 'Chargement...',
    repeat: 'Je répète!',
    IncorrectLogisticsInformation: "La méthode d'expédition ne peut pas être vide",
    PictureCannotBeEmpty: "L'image ne peut pas être vide",
    SKUCannotBeEmpty: 'SKU ne peut pas être vide',
    inputLength: 'Longueur inférieure à 255',
    richTextCheck: 'Le texte riche ne peut pas dépasser 40 000 mots',
    CompareAtPriceCheck: 'The Comparison at the price must be higher than the suggested price',
    CompareAtPriceCheckShoplazza: 'La comparaison des prix doit être supérieure à',
    titleCheck: 'Le titre ne peut pas être vide',
    DescriptionCheck: 'La description ne peut pas être vide',
    ShelfStatusUp: "le produit sera vendu en magasin à l'avance",
    ShelfStatusDowm: 'le produit était déjà disponible dans ce magasin.',
    ProfitMargin: 'Marge bénéficiaire',
    imageMaxLengthTips: "Jusqu'à 250 images peuvent être sélectionnées",
    imageMaxLengthTips2: "Jusqu'à 40 images peuvent être sélectionnées",
    tagLength: "Définir jusqu'à 10 étiquettes",
    isFilterDuplicateSpuText: 'Le même produit sera commercialisé à plusieurs reprises',
    beenListed: 'Échec. Le projet est déjà listé.'
  },
  publishListings: {
    listings: 'Liste',
    Published: 'Publications',
    Hidden: 'Caché',
    ListingQueue: "Liste des files d'attente",
    Deleted: 'Supprimer',
    productSelected: 'Produits sélectionnés',
    Product: 'Produits',
    ProductId: 'ID du produit',
    priceScope: 'Gamme de prix',
    CompareAtPrice: 'Comparaison des prix',
    Inventory: 'Inventaire',
    EditProduct: 'Modifier le produit',
    More: 'Plus',
    Synchronous: 'Synchrone',
    Relist: 'Reconnecter',
    PublishedIn: 'Publié dans ...',
    Delete: 'Supprimer',
    synType1Title: 'Dans la liste...',
    synType5Title: 'À propos de la republication...',
    synType4Title: 'Caché dans un magasin...',
    synType10Title: 'Synchroniser...',
    synType2Title: "Synchroniser les informations d'édition..",
    noProduct: "Désolé, vous n'avez pas ajouté de produit",
    ChooseProduct: 'Sélectionner un produit',
    ConnectANewStore: 'Connexion au nouveau magasin',
    hiddenComfirmTitle: 'Êtes - vous sûr de vouloir sortir le produit du magasin?',
    RelistComfirmTitle: 'Êtes - vous sûr de vouloir reconnecter le produit au magasin?',
    deleteComfirmTitle: 'Êtes - vous sûr de vouloir supprimer le produit de votre boutique?',
    synType3Title: 'Supprimer...',
    searchBy: 'Contenu de la recherche',
    SelectStore: 'Sélectionner un magasin',
    store: 'Magasins',
    productName: 'Nom du produit'
  },
  productList: {
    wishList: 'Liste des souhaits',
    productList: 'Liste des produits',
    Delete: 'Supprimer',
    productSelected: 'Produits sélectionnés',
    deleteTip1: 'Êtes - vous sûr de vouloir supprimer le produit sélectionné?',
    submit: 'Présentation',
    cancel: 'Annulation',
    Description: 'Description',
    Inventory: 'Inventaire',
    Price: 'Prix',
    ProductType: 'Type de produit',
    Action: 'Action',
    Detail: 'Détail',
    more: 'Plus',
    ListToStore: 'Liste à stocker',
    customized: 'Sur mesure',
    goodsInStock: 'Marchandises en stock',
    tatusTips: "Ce produit n'est pas disponible.",
    canFind: "Désolé, je n'ai pas pu le trouver.",
    ItemNo: 'Numéro du projet',
    contentPlaceholder: 'Veuillez saisir le mot - clé du produit',
    Listing: 'Mise sur le marché',
    YourPrice: 'Votre prix',
    From: 'De',
    ShipTo: 'Le bateau arrive.',
    Cancel: 'Annulation',
    ListNow: 'Liste maintenant',
    Platform: 'Plate - forme',
    Store: 'Magasins',
    ShipMyOdersMostTo: 'Livraison maximale de la commande',
    ShippingMethod: 'Voies de transport',
    logisticsTips: "Tant que vous choisissez l'un des sites d'expédition, de réception et de logistique, vous devez sélectionner tout cela",
    batchPublishTips: "Télécharger jusqu'à 100 listes à la fois",
    storeTips: 'Ne peut être téléchargé que sur 1 magasin à la fois',
    priceTips: 'Votre prix = prix * Entrez le facteur (Entrez le temps au lieu du taux).',
    shipTips: "Le modèle logistique sélectionné n'est utilisé que pour la logistique supportée par le système",
    ShippingMethodTips: "Facultatif (vous pouvez ajuster avant l'expédition)",
    inputPlaceholder: 'Contenu de la recherche',
    haveShelves: 'Échec de la liste: contient des éléments qui ne sont pas disponibles.',
    textareaPlaceholder: 'Séparer plusieurs recherches par des virgules ou des sauts de ligne',
    repeatListTip: 'Le même produit sera commercialisé à plusieurs reprises',
    repeatList: 'Dupliquer la Liste',
    priceRatioGT20Tip: 'Les produits que vous téléchargez seront téléchargés à 20 fois le prix de vente',
    yourPrice: 'Votre prix'
  },
  batchTasks: {
    batchTasks: 'Tâches par lots',
    Status: 'État',
    contentPlaceholder: 'Recherche',
    Number: 'nombre',
    StoreInformation: 'Stockage des informations',
    ItemNo: 'Numéro du projet',
    PublicationSituation: 'Publications',
    FailedToLoad: 'Impossible de charger',
    Success: 'Succès',
    uploading: 'Télécharger',
    ListingFailed: 'Échec de la mise sur le marché',
    CreationTime: 'Temps de création',
    Pending: 'En attente',
    Processing: 'Traitement',
    Completed: 'Complet',
    contentPlaceholder2: "Recherche de numéros d'articles",
    Platform: 'Plate - forme',
    Store: 'Centre commercial',
    Product: 'Produits',
    ReasonForFailure: "Raisons de l'échec",
    data: 'Données'
  }
}
